import { authenticateByCredentials } from '../../shared/services/auth.service.js';
import alerts from '../../shared/utils/alerts.js';
import { clearBrowserSession } from '../../shared/utils/session.js';

/** @type {HTMLFormElement|null} */
const loginForm = document.querySelector('#login-form');
if (!loginForm) throw new Error('Login form not found');

/** @type {Record<string, string>} */
const ERROR_MESSAGES = {
  session_expired: "Your session has expired. Please sign in again.",
  invalid_code: 'The link you followed is invalid or has expired. Please sign in.',
};

const params = new URLSearchParams(window.location.search);
const code = params.get('e');
const shouldClear = params.get('clear') === '1' || code === 'session_expired';

if (shouldClear) clearBrowserSession();

if (code && ERROR_MESSAGES[code]) {
  alerts.show('error', [ERROR_MESSAGES[code]]);
}

if (shouldClear || (code && ERROR_MESSAGES[code])) {
  params.delete('clear');
  params.delete('e');

  const query = params.toString();
  const nextUrl = query
    ? `${window.location.pathname}?${query}`
    : window.location.pathname;

  window.history.replaceState({}, '', nextUrl);
}

loginForm.addEventListener('submit', async e => {
  e.preventDefault();
  alerts.clear();

  const payload = {
    email: loginForm.email.value,
    dob:   loginForm.dob.value,
    next:  loginForm.next.value,
  };

  try {
    const res = await authenticateByCredentials(payload);

    if (res.success) {
      alerts.show('success', [res.message || 'Login successful. Redirecting…']);
      window.location = res.data.next;
      return;
    }

    if (res.errors) {
      Object.entries(res.errors).forEach(([field, msgs]) => {
        const el = loginForm.querySelector(`.error-${field}`);
        if (el) el.textContent = Array.isArray(msgs) ? msgs.join(', ') : msgs;
      });
    }

    if (res.message) {
      alerts.show('error', [res.message]);
    }
  } catch {
    alerts.show('error', ['Unable to log in. Please try again.']);
  }
});

